// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__3ttFf","messages":"Chat_messages__1ufj4","dateDivider":"Chat_dateDivider__JjDYG"};